export const ROOT = 'MyAccount/listAvailable/announcement';

export const FETCH_ANNOUNCEMENT_REQUEST = `${ROOT}/FETCH_ANNOUNCEMENT_REQUEST`;
export const FETCH_ANNOUNCEMENT_FAILURE = `${ROOT}/FETCH_ANNOUNCEMENT_FAILURE`;
export const FETCH_ANNOUNCEMENT_SUCCESS = `${ROOT}/FETCH_ANNOUNCEMENT_SUCCESS`;

export const DELETE_ANNOUNCEMENT_REQUEST = `${ROOT}/DELETE_ANNOUNCEMENT_REQUEST`;
export const DELETE_ANNOUNCEMENT_FAILURE = `${ROOT}/DELETE_ANNOUNCEMENT_FAILURE`;
export const DELETE_ANNOUNCEMENT_SUCCESS = `${ROOT}/DELETE_ANNOUNCEMENT_SUCCESS`;

export const REPUBLISH_ANNOUNCEMENT_REQUEST = `${ROOT}/REPUBLISH_ANNOUNCEMENT_REQUEST`;
export const REPUBLISH_ANNOUNCEMENT_FAILURE = `${ROOT}/REPUBLISH_ANNOUNCEMENT_FAILURE`;
export const REPUBLISH_ANNOUNCEMENT_SUCCESS = `${ROOT}/REPUBLISH_ANNOUNCEMENT_SUCCESS`;

export const PUT_ANNOUNCEMENT_REQUEST = `${ROOT}/PUT_ANNOUNCEMENT_REQUEST`;
export const PUT_ANNOUNCEMENT_FAILURE = `${ROOT}/PUT_ANNOUNCEMENT_FAILURE`;
export const PUT_ANNOUNCEMENT_SUCCESS = `${ROOT}/PUT_ANNOUNCEMENT_SUCCESS`;

export const SELECT_ANNOUNCEMENT = `${ROOT}/SELECT_ANNOUNCEMENT`;

export const CLEAR_ANNOUNCEMENT_DELETE_DATA = `${ROOT}/CLEAR_ANNOUNCEMENT_DELETE_DATA`;
export const CLEAR_ANNOUNCEMENT_PUT_INACTIVE_DATA = `${ROOT}/CLEAR_ANNOUNCEMENT_PUT_INACTIVE_DATA`;
export const CLEAR_ANNOUNCEMENT_REPUBLISH_DATA = `${ROOT}/CLEAR_ANNOUNCEMENT_REPUBLISH_DATA`;
export const CLEAR_ANNOUNCEMENT_SELECTEDS = `${ROOT}/CLEAR_ANNOUNCEMENT_SELECTEDS`;

export const SET_ANNOUNCEMENT_STATE = `${ROOT}/SET_ANNOUNCEMENT_STATE`;
export const SET_ANNOUNCEMENT_PAGE = `${ROOT}/SET_ANNOUNCEMENT_PAGE`;